<template>
  <div class="course-page-app" v-if="courseLoaded">

    <!-- BANNER TOPO -->
    <course-page :course="course">
      <template v-slot:header>
        <div class="banner-course-app" v-if="course.coverUrl" :style="{ backgroundImage: `url(${course.coverUrl})` }">
          <h2 class="title">{{ course.title }}</h2>
        </div>

        <div class="banner-course-app" v-else>
          <h2 class="title">{{ course.title }}</h2>
        </div>

        <course-page-header  v-if="courseLoaded" :course="course" :user-has-course="userHasCourse" :loading-add="loadingAdd"
                            @addCourse="addCourse"
                            @buyCourse="dialogPayment = true">
        </course-page-header>
      </template>


    </course-page>

    <v-snackbar
      v-model="alert.show"
      :color="alert.color"
    >
      <v-row no-gutters>
        <v-col cols="10" class="text-left">
          {{ alert.text }}
        </v-col>
        <v-col cols="2" class="text-right">
          <v-btn
            text
            icon
            x-small
            @click="alert.show = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-snackbar>

    <modal-course-payment :price="course.price" :course-id="course._id" :pass-on-tax="course.passOnTax"
                          :show="dialogPayment" @close="dialogPayment = false"></modal-course-payment>

  </div>
</template>

<script>

import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import ModalCoursePayment from '@/components/ModalCoursePayment'
import CoursePage from '@/components/CoursePage'
import CoursePageHeader from '@/components/CoursePageHeader'
import { CourseModel } from '@/models/Course'

library.add(faSpinner)

export default {
  name: 'UserCoursePage',
  components: { CoursePageHeader, ModalCoursePayment, CoursePage },
  data () {
    return {
      loadingAdd: false,
      dialogPayment: false,
      courseLoaded: false,
      userHasCourse: false,
      course: {},
      alert: {
        show: false,
        text: null,
        color: null
      }
    }
  },
  created () {
    this.getCourse()
  },
  methods: {
    addCourse () {
      if (this.userHasCourse) {
        this.$router.push({ name: 'take-course', params: { course_id: this.course._id } })
        return false
      }

      this.loadingAdd = true

      /* eslint-disable no-undef */
      grecaptcha.ready(() => {
        grecaptcha.execute(process.env.VUE_APP_RECAPTCHA_KEY_SITE, { action: 'submit' }).then(token => {
          this.axios.post(`/user/course/enter`, { slug: this.course.slug, token }).then(({ data }) => {
            if (data.success) {
              this.$router.push({ name: 'take-course', params: { course_id: this.course._id } })
            } else {
              this.alert.color = 'error'
              this.alert.text = data.message
              this.alert.show = true
            }
          }).catch(err => {
            console.error(err)

            this.alert.color = 'error'
            this.alert.text = 'Erro ao entrar no curso'
            this.alert.show = true
          }).finally(() => {
            this.loadingAdd = false
          })
        }).catch(err => {
          console.error(err)

          this.alert.text = 'Erro ao buscar o reCaptcha'
          this.alert.color = 'error'
          this.alert.show = true
        })
      })
    },
    getCourse () {
      this.axios.get(`/user/course/view/${this.$route.params.slug}`).then(({ data }) => {
        if (data.success) {
          this.course = new CourseModel(data.course)

          if (data.userHasCourse) {
            this.userHasCourse = data.userHasCourse
          }
        } else {
          this.alert.text = data.message
          this.alert.color = 'error'
          this.alert.show = true

          setTimeout(() => {
            this.$router.push({ name: 'course-list' })
          }, 3000)

        }
      }).catch(err => {
        console.error(err)

        this.alert.text = 'Erro ao carregar o curso'
        this.alert.color = 'error'
        this.alert.show = true
      }).finally(() => {
        this.courseLoaded = true
      })
    },
  }
}
</script>
